<template>
  <li
    class="category-block"
    :style="{backgroundImage: 'url(' + categoryImage(category) + ')'}"
    role="menuitem"
  >
    <router-link
      :to="{name: 'PersonalizedEdit', params: {category: category.id}}"
      tag="a"
    >
      <div class="poi-category" role="presentation">
        <div class="description-card" role="presentation">
          <h1>{{ $tr(category.name) }}</h1>
          <p class="description-text sub-description">{{ $tr(category.description) }}</p>
          <p class="description-text">({{ category.poiCount}} {{ $tc('message.location', category.poiCount) }})</p>
        </div>
      </div>
    </router-link>
  </li>
</template>

<script>
export default {
  name: 'CategoryBlock',
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  methods: {
    categoryImage: function (category) {
      if (category.mainImage) {
        return category.mainImage.url
      } else if (category.poiImage) {
        return category.poiImage.url
      } else {
        return require('@/assets/promo-students.jpg')
      }
    }
  }
}
</script>

<style lang="stylus">
  .category-block
    border-width 2px
    border-style solid
    background-size cover
    background-position center
    a
      text-decoration none
    .poi-category
      color white
      display flex
      background-color rgba(0, 0, 0, 0.4)
      .description-card
        text-align center
        width 100%
        .description-text
          font-size 21px
        .sub-description
          height: 64px;
          line-height 21px
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 80%;
          margin: 0 auto;
</style>
